module.exports = __webpack_public_path__ + "static/media/privacypolicy.a0c83dbb.htm";